(function () {
  var TIME_SLOTS = [
    '09:30 am',
    '10:00 am',
    '10:30 am',
    '11:00 am',
    '11:30 am',
    '12:00 pm',
    '12:30 pm',
    '01:00 pm',
    '01:30 pm',
    '02:00 pm',
    '02:30 pm',
  ];

  var STEP_LABELS = {
    1: 'Step 1 of 3 — Your Details',
    2: 'Step 2 of 3 — Camp Details',
    3: 'Step 3 of 3 — Your Experience',
  };

  function readStepLabels(modal) {
    return {
      1: (modal && modal.getAttribute('data-step-label-1')) || STEP_LABELS[1],
      2: (modal && modal.getAttribute('data-step-label-2')) || STEP_LABELS[2],
      3: (modal && modal.getAttribute('data-step-label-3')) || STEP_LABELS[3],
    };
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function formatOrdinal(day) {
    if (day > 3 && day < 21) return day + 'th';
    switch (day % 10) {
      case 1:
        return day + 'st';
      case 2:
        return day + 'nd';
      case 3:
        return day + 'rd';
      default:
        return day + 'th';
    }
  }

  function formatBookingLabel(date) {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return (
      days[date.getDay()] +
      ', ' +
      formatOrdinal(date.getDate()) +
      ' ' +
      months[date.getMonth()]
    );
  }

  function formatSummaryDateTime(date, time) {
    var months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return (
      formatOrdinal(date.getDate()) +
      ' ' +
      months[date.getMonth()] +
      ' ' +
      time.toUpperCase() +
      ' (Your Local Time)'
    );
  }

  function parseTimeSlot(date, timeStr) {
    var match = timeStr.match(/^(\d{1,2}):(\d{2})\s*(am|pm)$/i);
    if (!match) return new Date(date);

    var hours = parseInt(match[1], 10);
    var minutes = parseInt(match[2], 10);
    var meridiem = match[3].toLowerCase();

    if (meridiem === 'pm' && hours < 12) hours += 12;
    if (meridiem === 'am' && hours === 12) hours = 0;

    var slot = new Date(date);
    slot.setHours(hours, minutes, 0, 0);
    return slot;
  }

  function formatICSLocalDate(date) {
    function pad(value) {
      return String(value).padStart(2, '0');
    }

    return (
      date.getFullYear() +
      pad(date.getMonth() + 1) +
      pad(date.getDate()) +
      'T' +
      pad(date.getHours()) +
      pad(date.getMinutes()) +
      pad(date.getSeconds())
    );
  }

  function buildICSContent(data, selectedDate, selectedTime) {
    if (!selectedDate || !selectedTime) return '';
    var start = parseTimeSlot(selectedDate, selectedTime);
    var end = new Date(start.getTime() + 30 * 60 * 1000);
    var uid = Date.now() + '-' + Math.random().toString(36).slice(2) + '@risenglide.com';
    var description = [
      '30 min screening call for ' + data.camp,
      'Applicant: ' + data.firstName + ' ' + data.lastName,
      'Email: ' + data.email,
    ].join('\\n');

    return [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Rise N Glide//Camp Application//EN',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      'UID:' + uid,
      'DTSTAMP:' + formatICSLocalDate(new Date()),
      'DTSTART:' + formatICSLocalDate(start),
      'DTEND:' + formatICSLocalDate(end),
      'SUMMARY:Rise N Glide Screening Call',
      'DESCRIPTION:' + description,
      'LOCATION:Video Call',
      'STATUS:CONFIRMED',
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\r\n');
  }

  function downloadICS(icsContent, filename) {
    if (!icsContent) return;
    var blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = filename || 'rise-n-glide-screening-call.ics';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 1000);
  }

  function getEmailConfig(modal) {
    return {
      shopEmail: (
        modal.getAttribute('data-notify-email') ||
        modal.getAttribute('data-shop-email') ||
        ''
      ).trim(),

      confirmationSubject: (
        modal.getAttribute('data-confirmation-subject') ||
        "Your Rise 'N Glide application was received"
      ).trim(),

      confirmationMessage: (function () {
        var raw = modal.getAttribute('data-confirmation-message') || '';

        if (!raw) return '';

        try {
          return JSON.parse(raw);
        } catch (error) {
          return raw;
        }
      })(),

      webhookUrl: (modal.getAttribute('data-apply-webhook-url') || '').trim(),
    };
  }

  function webhookConfigured(modal) {
    return !!getEmailConfig(modal).webhookUrl;
  }

  function buildConfirmationMessage(modal, data) {
    var config = getEmailConfig(modal);
  
    var template =
      config.confirmationMessage ||
      "Hi {{first_name}},\n\n" +
      "Thank you for applying to Rise 'N Glide{{camp_line}}.\n\n" +
      "We have received your application and will review it within 24–48 hours.\n\n" +
      "{{booking_line}}\n\n" +
      "If you have any questions, reply to this email.\n\n" +
      "— Rise 'N Glide";
  
    var campLine = data.camp
      ? ' for ' + data.camp
      : '';
  
    var bookingLine =
      data.bookingDate && data.bookingTime
        ? 'Your screening call is booked for ' +
          data.bookingDate +
          ' at ' +
          data.bookingTime +
          ' (your local time).'
        : '';
  
    var bookingSummary =
      data.bookingDate && data.bookingTime
        ? data.bookingDate +
          ' at ' +
          data.bookingTime +
          ' (Your Local Time)'
        : '';
  
    return template
      .replace(/\{\{first_name\}\}/g, data.firstName || '')
      .replace(/\{\{last_name\}\}/g, data.lastName || '')
      .replace(
        /\{\{full_name\}\}/g,
        (data.firstName + ' ' + data.lastName).trim()
      )
      .replace(/\{\{email\}\}/g, data.email || '')
      .replace(/\{\{camp\}\}/g, data.camp || '')
      .replace(/\{\{camp_line\}\}/g, campLine)
      .replace(/\{\{booking_line\}\}/g, bookingLine)
      .replace(/\{\{booking_summary\}\}/g, bookingSummary)
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  function waitForCaptchaProtect(maxMs) {
    return new Promise(function (resolve) {
      var start = Date.now();

      function check() {
        if (
          window.Shopify &&
          window.Shopify.captcha &&
          typeof window.Shopify.captcha.protect === 'function'
        ) {
          resolve(true);
          return;
        }

        if (Date.now() - start >= maxMs) {
          resolve(false);
          return;
        }

        window.setTimeout(check, 50);
      }

      check();
    });
  }

  function readCaptchaToken(form) {
    if (!form) return '';

    var nodes = form.querySelectorAll(
      '[name="h-captcha-response"], textarea[name="h-captcha-response"]'
    );
    var i;
    for (i = 0; i < nodes.length; i++) {
      var value = nodes[i].value || nodes[i].textContent || '';
      if (String(value).trim()) return String(value).trim();
    }

    // Widget sometimes mounts the token field as a sibling near the form.
    var nearby = document.querySelector(
      'textarea[name="h-captcha-response"], [name="h-captcha-response"]'
    );
    if (nearby && String(nearby.value || '').trim()) {
      return String(nearby.value).trim();
    }

    return '';
  }

  function waitForCaptchaToken(form, maxMs) {
    return new Promise(function (resolve) {
      var start = Date.now();

      function check() {
        var token = readCaptchaToken(form);
        if (token) {
          resolve(token);
          return;
        }

        if (Date.now() - start >= maxMs) {
          resolve('');
          return;
        }

        window.setTimeout(check, 100);
      }

      check();
    });
  }

  function ensureCaptchaTokenField(form, token) {
    if (!form || !token) return;

    var field =
      form.querySelector('[name="h-captcha-response"]') ||
      form.querySelector('textarea[name="h-captcha-response"]');

    if (!field) {
      field = document.createElement('textarea');
      field.name = 'h-captcha-response';
      field.style.display = 'none';
      form.appendChild(field);
    }

    field.value = token;
  }

  function postShopifyContact(form) {
    var formData = new FormData(form);
    var token = readCaptchaToken(form);

    if (token) {
      formData.set('h-captcha-response', token);
    }

    return fetch(form.action || '/contact', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response
          .text()
          .then(function (text) {
            var payload = null;
            try {
              payload = text ? JSON.parse(text) : null;
            } catch (error) {
              payload = null;
            }

            if (payload && payload.errors) {
              console.error('[RNG Apply] Shopify contact errors:', payload.errors);
              return false;
            }

            if (!response.ok) {
              console.error(
                '[RNG Apply] Shopify contact rejected:',
                response.status,
                text.slice(0, 300)
              );
              return false;
            }

            if (payload) {
              return !!(payload.posted_successfully || payload.success);
            }

            return true;
          })
          .catch(function () {
            return response.ok;
          });
      })
      .catch(function (error) {
        console.error('[RNG Apply] Shopify contact failed:', error);
        return false;
      });
  }

  function submitShopifyContactViaIframe(form) {
    return new Promise(function (resolve) {
      var iframeName = 'rng-apply-contact-' + Date.now();
      var iframe = document.createElement('iframe');
      iframe.name = iframeName;
      iframe.setAttribute('title', 'Application submit');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText =
        'position:absolute;width:0;height:0;border:0;clip:rect(0,0,0,0);';
      document.body.appendChild(iframe);

      var settled = false;
      var submitted = false;
      var previousTarget = form.getAttribute('target');

      function finish(ok) {
        if (settled) return;
        settled = true;

        if (previousTarget == null) {
          form.removeAttribute('target');
        } else {
          form.setAttribute('target', previousTarget);
        }

        window.setTimeout(function () {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }, 500);

        resolve(!!ok);
      }

      iframe.addEventListener('load', function () {
        if (!submitted) return;

        try {
          var href =
            (iframe.contentWindow && iframe.contentWindow.location.href) || '';
          var doc = iframe.contentDocument;
          var text =
            doc && doc.body
              ? String(doc.body.innerText || doc.body.textContent || '')
              : '';

          if (
            /missing captcha|invalid captcha|captcha token/i.test(text) ||
            href.indexOf('/challenge') !== -1
          ) {
            console.error(
              '[RNG Apply] Captcha failed in contact submit:',
              text.slice(0, 200)
            );
            finish(false);
            return;
          }

          finish(true);
        } catch (error) {
          finish(true);
        }
      });

      form.setAttribute('target', iframeName);
      submitted = true;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }

      window.setTimeout(function () {
        console.error('[RNG Apply] Contact form iframe submit timed out.');
        finish(false);
      }, 15000);
    });
  }

  function submitShopifyContact(form) {
    if (!form) {
      return Promise.resolve(false);
    }

    // Shopify only accepts contact posts with a real hCaptcha token.
    // protect() wires the form; we wait for the token, then POST.
    return waitForCaptchaProtect(5000).then(function (ready) {
      if (!ready) {
        console.error(
          '[RNG Apply] Shopify.captcha.protect unavailable — cannot submit contact form.'
        );
        return false;
      }

      return new Promise(function (resolve) {
        try {
          window.Shopify.captcha.protect(form, function () {
            waitForCaptchaToken(form, 8000).then(function (token) {
              if (token) {
                ensureCaptchaTokenField(form, token);
                postShopifyContact(form).then(resolve);
                return;
              }

              console.warn(
                '[RNG Apply] No captcha token after protect; trying native submit.'
              );
              submitShopifyContactViaIframe(form).then(resolve);
            });
          });
        } catch (error) {
          console.error('[RNG Apply] Captcha protect failed:', error);
          resolve(false);
        }
      });
    });
  }

  function resolveContactForm(root, modal) {
    // Prefer the permanent modal contact form — never the cloned page-form copy.
    if (modal) {
      var permanent = qs(modal, '[data-rng-apply-contact-form]');
      if (permanent && !permanent.closest('[data-rng-apply-form-host]')) {
        return permanent;
      }
    }

    if (root) {
      var fromRoot = qs(root, '[data-rng-apply-contact-form]');
      if (fromRoot) return fromRoot;
    }

    return (
      (modal && qs(modal, '#RngApplyContactForm')) ||
      (root && qs(root, '#RngApplyContactForm')) ||
      null
    );
  }

  function sendApplicationWebhook(modal, data, body, icsContent) {
    var config = getEmailConfig(modal);

    if (!config.webhookUrl) {
      return Promise.resolve({
        storeOk: false,
        confirmationOk: false,
        skipped: true,
      });
    }

    return fetch(config.webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        type: 'camp_application',
        applicant: data,
        application_body: body,
        ics: icsContent,
        notify_email: config.shopEmail,
        confirmation_subject: config.confirmationSubject,
        confirmation_message: buildConfirmationMessage(modal, data),
        shop_domain: window.location.hostname,
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          return {
            storeOk: false,
            confirmationOk: false,
          };
        }

        return response.json().then(function (payload) {
          if (!payload || typeof payload !== 'object') {
            return {
              storeOk: response.ok,
              confirmationOk: false,
            };
          }

          return {
            storeOk: !!(
              payload.store_email_sent ||
              payload.storeOk ||
              payload.success
            ),
            confirmationOk: !!(
              payload.applicant_email_sent ||
              payload.confirmationOk ||
              payload.success
            ),
          };
        });
      })
      .catch(function (error) {
        console.error('[RNG Apply] Webhook failed:', error);
        return {
          storeOk: false,
          confirmationOk: false,
        };
      });
  }

  function parseNotifyEmails(raw) {
    return String(raw || '')
      .split(/[,;]+/)
      .map(function (email) {
        return email.trim();
      })
      .filter(Boolean);
  }

  function sendNotifyEmailsFallback(modal, data, body) {
    var config = getEmailConfig(modal);
    var emails = parseNotifyEmails(config.shopEmail);

    if (!emails.length) {
      return Promise.resolve({
        storeOk: false,
        confirmationOk: false,
      });
    }

    var primary = emails[0];
    var cc = emails.slice(1).join(',');
    var applicantName =
      (data.firstName + ' ' + data.lastName).trim() || data.email || 'Applicant';

    var screening =
      data.bookingDate && data.bookingTime
        ? data.bookingDate + ' at ' + data.bookingTime
        : '';

    var detailLines = [
      'Camp Application',
      '----------------',
      'Full Name: ' + applicantName,
      'First Name: ' + (data.firstName || '—'),
      'Last Name: ' + (data.lastName || '—'),
      'Email: ' + (data.email || '—'),
      'Instagram: ' + (data.instagram || '—'),
      'Gender: ' + (data.gender || '—'),
      'Age: ' + (data.age || '—'),
      'Camp: ' + (data.camp || '—'),
      'Experience: ' + (data.experience || '—'),
    ];

    if (Array.isArray(data.extraFields)) {
      data.extraFields.forEach(function (field) {
        if (!field) return;
        detailLines.push(
          (field.label || 'Field') + ': ' + (field.value || '—')
        );
      });
    }

    if (screening) {
      detailLines.push('Screening Call: ' + screening);
    }

    if (body && String(body).trim()) {
      detailLines.push('');
      detailLines.push('Raw submission:');
      detailLines.push(String(body).trim());
    }

    var applicationDetails = detailLines.join('\n');

    // Prefer FormData — FormSubmit renders these labeled fields reliably.
    var formData = new FormData();
    formData.append('_subject', "Rise 'N Glide Camp Application — " + applicantName);
    formData.append('_replyto', data.email || primary);
    formData.append('_template', 'box');
    formData.append('_captcha', 'false');
    if (cc) formData.append('_cc', cc);

    formData.append('Full Name', applicantName || '—');
    formData.append('First Name', data.firstName || '—');
    formData.append('Last Name', data.lastName || '—');
    formData.append('Email', data.email || '—');
    formData.append('Instagram', data.instagram || '—');
    formData.append('Gender', data.gender || '—');
    formData.append('Age', data.age || '—');
    formData.append('Camp', data.camp || '—');
    formData.append('Experience', data.experience || '—');
    if (screening) formData.append('Screening Call', screening);

    if (Array.isArray(data.extraFields)) {
      data.extraFields.forEach(function (field) {
        if (!field || !field.label) return;
        formData.append(String(field.label), field.value || '—');
      });
    }

    formData.append('message', applicationDetails);
    formData.append('Application Details', applicationDetails);

    return fetch(
      'https://formsubmit.co/ajax/' + encodeURIComponent(primary),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      }
    )
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return null;
          })
          .then(function (payloadJson) {
            var ok =
              response.ok &&
              !(
                payloadJson &&
                (payloadJson.success === 'false' ||
                  payloadJson.success === false ||
                  payloadJson.error)
              );

            if (!ok) {
              console.error(
                '[RNG Apply] Notify email fallback failed:',
                response.status,
                payloadJson
              );
            } else {
              console.log(
                '[RNG Apply] Notify email sent via fallback to:',
                emails.join(', '),
                '| details length:',
                applicationDetails.length
              );
            }

            return {
              storeOk: ok,
              confirmationOk: false,
            };
          });
      })
      .catch(function (error) {
        console.error('[RNG Apply] Notify email fallback error:', error);
        return {
          storeOk: false,
          confirmationOk: false,
        };
      });
  }

  function deliverApplicationEmails(modal, data, body, contactForm, icsContent) {
    if (webhookConfigured(modal)) {
      return sendApplicationWebhook(modal, data, body, icsContent).then(
        function (result) {
          if (result.skipped) {
            return sendNotifyEmailsFallback(modal, data, body).then(function (
              fallback
            ) {
              if (fallback.storeOk) return fallback;
              return submitShopifyContact(contactForm).then(function (storeOk) {
                return {
                  storeOk: storeOk,
                  confirmationOk: false,
                };
              });
            });
          }

          if (result.storeOk && result.confirmationOk) {
            return result;
          }

          if (result.storeOk) {
            return {
              storeOk: true,
              confirmationOk: result.confirmationOk,
            };
          }

          return sendNotifyEmailsFallback(modal, data, body).then(function (
            fallback
          ) {
            if (fallback.storeOk) {
              return {
                storeOk: true,
                confirmationOk: result.confirmationOk,
              };
            }

            return submitShopifyContact(contactForm).then(function (storeOk) {
              return {
                storeOk: storeOk,
                confirmationOk: result.confirmationOk,
              };
            });
          });
        }
      );
    }

    console.warn(
      '[RNG Apply] No webhook URL configured. Sending store notify emails via fallback to:',
      getEmailConfig(modal).shopEmail
    );

    return sendNotifyEmailsFallback(modal, data, body).then(function (fallback) {
      if (fallback.storeOk) {
        return fallback;
      }

      return submitShopifyContact(contactForm).then(function (storeOk) {
        return {
          storeOk: storeOk,
          confirmationOk: false,
        };
      });
    });
  }

  function ApplyModal(modal) {
    this.modal = modal;
    this.currentStep = 1;
    this.calendarMonth = new Date();
    this.calendarMonth.setDate(1);
    this.selectedDate = null;
    this.selectedTime = null;
    this.prefillCamp = '';
    // Theme Editor only: interactive X/backdrop/Escape dismiss sticks until
    // section re-render / re-select (setting still on may reopen then).
    this.editorPreviewDismissed = false;
    this.stepLabels = readStepLabels(modal);

    this.progressWrap = qs(modal, '[data-rng-apply-progress-wrap]');
    this.progress = qs(modal, '[data-rng-apply-progress]');
    this.stepLabel = qs(modal, '[data-rng-apply-step-label]');
    this.stepLabelText = qs(modal, '[data-rng-apply-step-label-text]');
    this.campSelect = qs(modal, '[data-rng-apply-camp-select]');
    this.calendarDays = qs(modal, '[data-rng-apply-calendar-days]');
    this.calendarMonthEl = qs(modal, '[data-rng-apply-calendar-month]');
    this.bookingDateLabel = qs(modal, '[data-rng-apply-booking-date-label]');
    this.timeSlotsEl = qs(modal, '[data-rng-apply-time-slots]');
    this.bookBtn = qs(modal, '[data-rng-apply-book]');
    this.bookBtnLabel = this.bookBtn ? this.bookBtn.textContent.trim() : 'Submit application';
    this.contactForm = resolveContactForm(modal, modal);
    this.calendarDownloadBtn = qs(modal, '[data-rng-apply-calendar-download]');
    this.lastICSContent = '';
    this.formRoot = modal;
    this.usingPageForm = false;
    this.hydratePromise = null;
    this.standalone = modal.hasAttribute('data-rng-apply-form') && !modal.hasAttribute('data-rng-apply-modal');
    this.skipBooking =
      modal.getAttribute('data-rng-apply-skip-booking') === 'true' ||
      !!qs(modal, '[data-rng-apply-skip-booking]');

    this.bindEvents();
    if (!this.skipBooking) {
      this.renderCalendar();
      this.renderTimeSlots();
    }
    this.updateBookingUI();
  }

  ApplyModal.prototype.bindEvents = function () {
    var self = this;
    var backdrop = qs(this.modal, '[data-rng-apply-backdrop]');

    if (backdrop) {
      backdrop.addEventListener('click', function () {
        self.close();
      });
    }

    this.modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-rng-apply-close]')) {
        self.close();
        return;
      }

      if (event.target.closest('[data-rng-apply-next]')) {
        if (!self.validateStep(self.currentStep)) return;
        if (self.skipBooking && self.currentStep === 3) {
          self.submitApplication();
          return;
        }
        if (self.currentStep === 3) {
          self.goToStep(4);
        } else {
          self.goToStep(self.currentStep + 1);
        }
        return;
      }

      if (event.target.closest('[data-rng-apply-back]')) {
        self.goToStep(self.currentStep - 1);
        return;
      }

      if (event.target.closest('[data-rng-apply-calendar-prev]')) {
        self.calendarMonth.setMonth(self.calendarMonth.getMonth() - 1);
        self.renderCalendar();
        return;
      }

      if (event.target.closest('[data-rng-apply-calendar-next]')) {
        self.calendarMonth.setMonth(self.calendarMonth.getMonth() + 1);
        self.renderCalendar();
        return;
      }

      if (event.target.closest('[data-rng-apply-book]')) {
        if (!self.skipBooking && (!self.selectedDate || !self.selectedTime)) return;
        if (!self.validateStep(self.currentStep)) return;
        self.submitApplication();
        return;
      }

      if (event.target.closest('[data-rng-apply-calendar-download]')) {
        if (!self.lastICSContent) return;
        downloadICS(self.lastICSContent, 'rise-n-glide-screening-call.ics');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.modal.classList.contains('is-open')) {
        self.close();
      }
    });
  };

  ApplyModal.prototype.refreshFormRefs = function () {
    var root = this.formRoot || this.modal;
    this.campSelect = qs(root, '[data-rng-apply-camp-select]');
    this.calendarDays = qs(root, '[data-rng-apply-calendar-days]');
    this.calendarMonthEl = qs(root, '[data-rng-apply-calendar-month]');
    this.bookingDateLabel = qs(root, '[data-rng-apply-booking-date-label]');
    this.timeSlotsEl = qs(root, '[data-rng-apply-time-slots]');
    this.bookBtn = qs(root, '[data-rng-apply-book]');
    this.bookBtnLabel = this.bookBtn ? this.bookBtn.textContent.trim() : this.bookBtnLabel;
    this.contactForm = resolveContactForm(root, this.modal);
    this.calendarDownloadBtn = qs(root, '[data-rng-apply-calendar-download]');
    this.skipBooking =
      (root.getAttribute && root.getAttribute('data-rng-apply-skip-booking') === 'true') ||
      this.modal.getAttribute('data-rng-apply-skip-booking') === 'true' ||
      !!qs(root, '[data-rng-apply-skip-booking]');
  };

  ApplyModal.prototype.injectPageForm = function (sourceForm) {
    var host = qs(this.modal, '[data-rng-apply-form-host]');
    var builtin = qs(this.modal, '[data-rng-apply-builtin]');
    if (!host || !sourceForm) return false;

    host.innerHTML = '';
    var section = sourceForm.closest('[id^="shopify-section-"]');
    if (section) {
      qsa(section, 'style').forEach(function (style) {
        host.appendChild(style.cloneNode(true));
      });
    }

    var clone = sourceForm.cloneNode(true);

    // Cloned Shopify contact forms break hCaptcha (duplicate IDs + no wire-up).
    // Always keep using the permanent modal contact form instead.
    qsa(clone, '[data-rng-apply-contact-form], #RngApplyContactForm, form[action*="/contact"]').forEach(
      function (form) {
        if (form && form.parentNode) form.parentNode.removeChild(form);
      }
    );

    host.appendChild(clone);
    host.hidden = false;
    if (builtin) builtin.hidden = true;

    this.formRoot = qs(host, '[data-rng-apply-form]') || host;
    this.usingPageForm = true;
    this.refreshFormRefs();
    this.updateBookingUI();
    return true;
  };

  ApplyModal.prototype.ensureHydrated = function () {
    var self = this;
    if (this.standalone) return Promise.resolve(false);
    if (this.usingPageForm && qs(this.modal, '[data-rng-apply-form-host] [data-rng-apply-form]')) {
      return Promise.resolve(true);
    }

    var live = document.querySelector('[data-rng-apply-form]');
    if (live && !this.modal.contains(live)) {
      this.injectPageForm(live);
      return Promise.resolve(true);
    }

    var url = this.modal.getAttribute('data-rng-apply-form-url');
    if (!url) return Promise.resolve(false);

    if (this.hydratePromise) return this.hydratePromise;

    this.hydratePromise = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var form = doc.querySelector('[data-rng-apply-form]');
        if (!form) {
          console.warn('[RNG Apply] No RNG Apply Form found on', url);
          return false;
        }
        return self.injectPageForm(form);
      })
      .catch(function (error) {
        console.error('[RNG Apply] Could not load apply form page:', error);
        self.hydratePromise = null;
        return false;
      });

    return this.hydratePromise;
  };

  ApplyModal.prototype.open = function (options) {
    var self = this;
    var opts = options || {};
    var skipReset = opts.skipReset === true;
    var startStep = parseInt(opts.step, 10);

    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    if (!this.standalone) {
      document.body.style.overflow = 'hidden';
    }

    this.ensureHydrated()
      .catch(function (error) {
        console.error('[RNG Apply] Could not load page form:', error);
        return false;
      })
      .then(function () {
      if (!skipReset) {
        self.reset();
      }

      if (self.prefillCamp && self.campSelect) {
        var option = Array.prototype.find.call(self.campSelect.options, function (opt) {
          return opt.value === self.prefillCamp;
        });
        if (option) {
          self.campSelect.value = self.prefillCamp;
        }
      }

      if (!isNaN(startStep) && startStep >= 1 && startStep <= 5) {
        self.goToStep(startStep);
      } else if (self.usingPageForm) {
        self.goToStep(1);
      }

      if (!skipReset) {
        var firstInput = qs(self.formRoot || self.modal, '#rng-apply-first-name');
        if (firstInput) {
          window.setTimeout(function () {
            firstInput.focus();
          }, 100);
        }
      }
    });
  };

  ApplyModal.prototype.close = function () {
    if (this.modal.getAttribute('data-editor-preview') === 'true') {
      this.editorPreviewDismissed = true;
    }

    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    if (!this.standalone) {
      document.body.style.overflow = '';
    }
    this.reset();
  };

  ApplyModal.prototype.reset = function () {
    this.currentStep = 1;
    this.selectedDate = null;
    this.selectedTime = null;
    this.prefillCamp = '';
    this.lastICSContent = '';
    this.calendarMonth = new Date();
    this.calendarMonth.setDate(1);

    qsa(this.formRoot || this.modal, 'input:not([type="hidden"])').forEach(function (input) {
      if (input.type === 'radio' || input.type === 'checkbox') {
        input.checked = false;
      } else {
        input.value = '';
      }
    });

    if (this.campSelect) {
      this.campSelect.selectedIndex = 0;
    }

    this.goToStep(1);
    if (!this.skipBooking) {
      this.renderCalendar();
      this.renderTimeSlots();
    }
    this.updateBookingUI();
  };

  ApplyModal.prototype.goToStep = function (step) {
    this.currentStep = step;
    var root = this.formRoot || this.modal;

    qsa(root, '[data-rng-apply-step]').forEach(function (panel) {
      var panelStep = parseInt(panel.getAttribute('data-rng-apply-step'), 10);
      var isActive = panelStep === step;
      panel.classList.toggle('hidden', !isActive);
      panel.hidden = !isActive;
    });

    var showProgress = !this.usingPageForm && step <= 3;
    if (this.progressWrap) {
      this.progressWrap.classList.toggle('hidden', !showProgress);
    }
    if (this.stepLabel) {
      this.stepLabel.classList.toggle('hidden', !showProgress);
    }

    if (showProgress && this.stepLabelText && this.progress) {
      this.stepLabelText.textContent = this.stepLabels[step];
      qsa(this.progress, '[data-segment]').forEach(function (segment) {
        var segmentStep = parseInt(segment.getAttribute('data-segment'), 10);
        segment.className = 'rng-apply-progress__segment h-[3px] flex-1';
        if (segmentStep < step) {
          segment.classList.add('is-complete');
          segment.innerHTML = '';
        } else if (segmentStep === step) {
          segment.classList.add('is-current');
          segment.innerHTML =
            '<span></span><span></span>';
        } else {
          segment.innerHTML = '';
        }
      });
    }

    if (step === 4 && !this.skipBooking) {
      this.renderCalendar();
      this.renderTimeSlots();
      this.updateBookingUI();
    }
  };

  ApplyModal.prototype.validateStep = function (step) {
    var root = this.formRoot || this.modal;
    var panel = qs(root, '[data-rng-apply-step="' + step + '"]');
    if (!panel) return true;

    var fields = qsa(panel, 'input, select, textarea').filter(function (el) {
      return el.hasAttribute('required');
    });

    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (field.type === 'radio') {
        var name = field.name;
        var checked = qs(panel, 'input[name="' + name + '"]:checked');
        if (!checked) {
          field.focus();
          return false;
        }
      } else if (!field.value.trim()) {
        field.focus();
        field.reportValidity();
        return false;
      }
    }

    var ageInput = qs(panel, '#rng-apply-age') || qs(this.formRoot || this.modal, '#rng-apply-age');
    if (ageInput && ageInput.value) {
      var age = parseInt(ageInput.value, 10);
      if (!isNaN(age) && age < 18) {
        ageInput.setCustomValidity('You must be 18 or older to apply.');
        ageInput.reportValidity();
        ageInput.setCustomValidity('');
        return false;
      }
    }

    return true;
  };

  ApplyModal.prototype.renderCalendar = function () {
    if (!this.calendarDays || !this.calendarMonthEl) return;

    var self = this;
    var year = this.calendarMonth.getFullYear();
    var month = this.calendarMonth.getMonth();
    var monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    this.calendarMonthEl.textContent = monthNames[month] + ' ' + year;
    this.calendarDays.innerHTML = '';

    var firstDay = new Date(year, month, 1).getDay();
    var adjustedFirst = firstDay === 0 ? 6 : firstDay - 1;
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    for (var i = 0; i < adjustedFirst; i++) {
      var spacer = document.createElement('span');
      spacer.className = 'h-10';
      this.calendarDays.appendChild(spacer);
    }

    for (var day = 1; day <= daysInMonth; day++) {
      (function (dayNum) {
        var date = new Date(year, month, dayNum);
        date.setHours(0, 0, 0, 0);
        var isPast = date < today;
        var isWeekend = date.getDay() === 0 || date.getDay() === 6;
        var isDisabled = isPast || isWeekend;
        var isSelected =
          self.selectedDate &&
          self.selectedDate.getFullYear() === year &&
          self.selectedDate.getMonth() === month &&
          self.selectedDate.getDate() === dayNum;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = String(dayNum);
        btn.disabled = isDisabled;
        btn.className =
          'rng-apply-calendar-day flex h-10 w-full items-center justify-center rounded-full text-[13px] font-bold transition';

        if (isSelected) {
          btn.classList.add('is-selected');
        } else if (isDisabled) {
          btn.classList.add('is-disabled');
        } else {
          btn.classList.add('is-available');
        }

        if (!isDisabled) {
          btn.addEventListener('click', function () {
            self.selectedDate = date;
            self.selectedTime = null;
            self.renderCalendar();
            self.renderTimeSlots();
            self.updateBookingUI();
          });
        }

        self.calendarDays.appendChild(btn);
      })(day);
    }
  };

  ApplyModal.prototype.renderTimeSlots = function () {
    if (!this.timeSlotsEl) return;

    var self = this;
    this.timeSlotsEl.innerHTML = '';

    if (!this.selectedDate) {
      var empty = document.createElement('p');
      empty.className = 'p-4 text-center text-brown-text/45';
      empty.textContent = 'Select a date to view available times';
      this.timeSlotsEl.appendChild(empty);
      return;
    }

    TIME_SLOTS.forEach(function (time) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = time;
      btn.className = 'rng-apply-time-slot w-full border-b border-brown-text/10 px-5 py-3.5 text-base font-semibold transition last:border-b-0';
      if (self.selectedTime === time) {
        btn.classList.add('is-selected');
      }
      btn.addEventListener('click', function () {
        self.selectedTime = time;
        self.renderTimeSlots();
        self.updateBookingUI();
      });
      self.timeSlotsEl.appendChild(btn);
    });
  };

  ApplyModal.prototype.updateBookingUI = function () {
    if (this.skipBooking) {
      if (this.bookBtn) this.bookBtn.disabled = false;
      return;
    }

    if (this.bookingDateLabel) {
      if (this.selectedDate) {
        this.bookingDateLabel.textContent =
          'You are booking for ' + formatBookingLabel(this.selectedDate);
      } else {
        this.bookingDateLabel.textContent = 'You are booking for —';
      }
    }

    if (this.bookBtn) {
      this.bookBtn.disabled = !(this.selectedDate && this.selectedTime);
    }
  };

  ApplyModal.prototype.collectExtraFields = function () {
    var extra = [];
    qsa(this.formRoot || this.modal, '[data-rng-apply-extra-field]').forEach(function (field) {
      extra.push({
        label: field.getAttribute('data-rng-apply-extra-label') || field.getAttribute('name') || 'Extra field',
        name: field.getAttribute('name') || '',
        value: (field.value || '').trim(),
        required: field.hasAttribute('required'),
        el: field,
      });
    });
    return extra;
  };

  ApplyModal.prototype.collectFormData = function () {
    var root = this.formRoot || this.modal;
    var firstNameEl = qs(root, '#rng-apply-first-name');
    var lastNameEl = qs(root, '#rng-apply-last-name');
    var emailEl = qs(root, '#rng-apply-email');
    var instagramEl = qs(root, '#rng-apply-instagram');
    var ageEl = qs(root, '#rng-apply-age');

    return {
      firstName: firstNameEl ? firstNameEl.value.trim() : '',
      lastName: lastNameEl ? lastNameEl.value.trim() : '',
      email: emailEl ? emailEl.value.trim() : '',
      instagram: instagramEl ? instagramEl.value.trim() : '',
      gender: (qs(root, 'input[name="gender"]:checked') || {}).value || '',
      age: ageEl ? ageEl.value.trim() : '',
      camp: this.campSelect ? this.campSelect.value : '',
      experience: (qs(root, 'input[name="experience"]:checked') || {}).value || '',
      extraFields: this.collectExtraFields(),
      bookingDate: this.selectedDate ? formatBookingLabel(this.selectedDate) : '',
      bookingTime: this.selectedTime || '',
    };
  };

  ApplyModal.prototype.submitApplication = function () {
    var self = this;
  
    var data = this.collectFormData();
  
    var missingRequired =
      data.extraFields.filter(function (field) {
        return field.required && !field.value;
      });
  
    if (missingRequired.length) {
      if (
        missingRequired[0].el &&
        missingRequired[0].el.reportValidity
      ) {
        missingRequired[0].el.reportValidity();
      }
  
      return;
    }
  
    var bodyLines = [
      'Camp Application',
      '---',
      'First Name: ' + data.firstName,
      'Last Name: ' + data.lastName,
      'Email: ' + data.email,
      'Instagram: ' + data.instagram,
      'Gender: ' + data.gender,
      'Age: ' + data.age,
      'Camp: ' + data.camp,
      'Experience: ' + data.experience
    ];
  
    data.extraFields.forEach(function (field) {
      bodyLines.push(
        field.label + ': ' + field.value
      );
    });
  
    if (
      data.bookingDate &&
      data.bookingTime
    ) {
      bodyLines.push(
        'Screening Call: ' +
          data.bookingDate +
          ' at ' +
          data.bookingTime
      );
    }
  
    var body = bodyLines.join('\n');
  
    this.refreshFormRefs();
  
    if (!this.contactForm) {
      console.error(
        '[RNG Apply] Contact form not found.'
      );
  
      return;
    }
  
    var nameField = qs(
      this.contactForm,
      '[data-rng-apply-form-name]'
    );
  
    var emailField = qs(
      this.contactForm,
      '[data-rng-apply-form-email]'
    );
  
    var bodyField = qs(
      this.contactForm,
      '[data-rng-apply-form-body]'
    );
  
    if (nameField) {
      nameField.value =
        (data.firstName + ' ' + data.lastName).trim();
    }
  
    if (emailField) {
      emailField.value = data.email;
    }
  
    if (bodyField) {
      bodyField.value = body;
    }
  
    var icsContent = this.skipBooking
      ? ''
      : buildICSContent(
          data,
          this.selectedDate,
          this.selectedTime
        );
  
    this.lastICSContent = icsContent;
  
    var emailSource = this.modal;
  
    if (this.usingPageForm) {
      var injectedForm = qs(
        this.modal,
        '[data-rng-apply-form-host] [data-rng-apply-form]'
      );
  
      if (injectedForm) {
        emailSource = injectedForm;
      }
    }
  
    if (this.bookBtn) {
      this.bookBtn.disabled = true;
  
      this.bookBtn.textContent =
        this.skipBooking
          ? 'Sending…'
          : 'Booking…';
    }
  
    deliverApplicationEmails(
      emailSource,
      data,
      body,
      this.contactForm,
      icsContent
    )
      .then(function (results) {
        var storeOk = results.storeOk;
        var confirmationOk = results.confirmationOk;

        console.log('[RNG Apply] Submission results:', {
          storeOk: storeOk,
          confirmationOk: confirmationOk,
        });
  
        if (
          !self.skipBooking &&
          icsContent
        ) {
          downloadICS(
            icsContent,
            'rise-n-glide-screening-call.ics'
          );
        }
  
        self.showConfirmation(data, {
          shopifyOk: storeOk,
          emailOk: confirmationOk,
        });
      })
      .catch(function (error) {
        console.error(
          '[RNG Apply] Submission failed:',
          error
        );

        if (
          !self.skipBooking &&
          icsContent
        ) {
          downloadICS(
            icsContent,
            'rise-n-glide-screening-call.ics'
          );
        }

        self.showConfirmation(data, {
          shopifyOk: false,
          emailOk: false,
        });
      })
      .finally(function () {
        if (self.bookBtn) {
          self.bookBtn.disabled =
            self.skipBooking
              ? false
              : !(
                  self.selectedDate &&
                  self.selectedTime
                );
  
          self.bookBtn.textContent =
            self.bookBtnLabel;
        }
      });
  };

  ApplyModal.prototype.showConfirmation = function (data, status) {
    var root = this.formRoot || this.modal;
    var summaryDateTime = qs(root, '[data-rng-apply-summary-datetime]');
    var summaryDetail = qs(root, '[data-rng-apply-summary-detail]');
    var confirmationEmail = qs(root, '[data-rng-apply-confirmation-email]');

    if (summaryDateTime && this.selectedDate && this.selectedTime) {
      summaryDateTime.textContent = formatSummaryDateTime(this.selectedDate, this.selectedTime);
    }
    if (summaryDetail && this.selectedDate) {
      summaryDetail.textContent =
        'You are booked for a 30 min screening call on ' +
        formatBookingLabel(this.selectedDate) +
        '.';
    }

    if (confirmationEmail) {
      if (this.skipBooking) {
        if (status.emailOk) {
          confirmationEmail.textContent =
            'A confirmation email has been sent to ' + data.email + '.';
        } else if (status.shopifyOk) {
          confirmationEmail.textContent =
            'Your application was received. We will follow up at ' +
            data.email +
            ' within 24–48 hours.';
        } else {
          confirmationEmail.textContent =
            'We could not confirm email delivery. Please try again, or email us directly if this continues.';
        }
      } else if (status.emailOk) {
        confirmationEmail.textContent =
          'A confirmation email has been sent to ' +
          data.email +
          '. Your calendar invite was also downloaded — open the .ics file if you need to add it manually.';
      } else if (status.shopifyOk) {
        confirmationEmail.textContent =
          'Your application was received. A calendar invite file was downloaded — open it to add the screening call to your calendar. We will follow up at ' +
          data.email +
          ' within 24–48 hours.';
      } else {
        confirmationEmail.textContent =
          'Your calendar invite was downloaded, but we could not confirm email delivery to the store. Please try submitting again.';
      }
    }

    this.goToStep(5);
  };

  var modalInstance = null;
  var formInstance = null;

  function getCampFromTrigger(trigger) {
    return (
      trigger.getAttribute('data-apply-camp') ||
      trigger.getAttribute('data-rng-apply-camp') ||
      ''
    );
  }

  function applyEditorPreview(instance) {
    if (!instance || !instance.modal) return;

    var modal = instance.modal;
    if (modal.getAttribute('data-editor-preview') !== 'true') return;

    var show = modal.getAttribute('data-editor-show') !== 'false';
    var step = parseInt(modal.getAttribute('data-editor-preview-step') || '1', 10);
    if (isNaN(step) || step < 1 || step > 5) step = 1;

    if (!show || instance.editorPreviewDismissed) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      return;
    }

    instance.open({ skipReset: true, step: step });
  }

  function getCampFromQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      return (params.get('camp') || '').trim();
    } catch (error) {
      return '';
    }
  }

  function applyCampPrefill(instance, campName) {
    if (!instance || !campName || !instance.campSelect) return;

    instance.prefillCamp = campName;
    var option = Array.prototype.find.call(instance.campSelect.options, function (opt) {
      return opt.value === campName || opt.text.trim() === campName;
    });
    if (!option) {
      option = Array.prototype.find.call(instance.campSelect.options, function (opt) {
        var value = (opt.value || '').toLowerCase();
        var text = (opt.text || '').toLowerCase();
        var needle = campName.toLowerCase();
        return value.indexOf(needle) !== -1 || text.indexOf(needle) !== -1 || needle.indexOf(value) !== -1;
      });
    }
    if (option) {
      instance.campSelect.value = option.value;
    }
  }

  function ensureModalInstance() {
    if (modalInstance) return modalInstance;

    var modal = document.querySelector('[data-rng-apply-modal]');
    if (!modal) {
      console.warn(
        '[RNG Apply] Modal not found. Check that sections/rng-apply-modal.liquid is included via {% sections \'rng-overlay-group\' %} in layout/theme-rng.liquid (and layout/theme.liquid).'
      );
      return null;
    }

    try {
      modalInstance = new ApplyModal(modal);
    } catch (error) {
      console.error('[RNG Apply] Failed to initialize modal:', error);
      return null;
    }

    return modalInstance;
  }

  function ensureFormInstance() {
    if (formInstance) return formInstance;

    var form = document.querySelector('[data-rng-apply-form]');
    if (!form || form.closest('[data-rng-apply-modal]')) return null;

    try {
      formInstance = new ApplyModal(form);
      applyCampPrefill(formInstance, getCampFromQuery());
    } catch (error) {
      console.error('[RNG Apply] Failed to initialize page form:', error);
      return null;
    }

    return formInstance;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rng-apply-open]');
    if (!trigger) return;

    // Prefer navigating to the apply page when the trigger has a real href.
    var href = trigger.getAttribute('href');
    if (href && href !== '#' && href.indexOf('javascript:') !== 0) {
      return;
    }

    var instance = ensureModalInstance();
    if (!instance) return;

    event.preventDefault();
    instance.prefillCamp = getCampFromTrigger(trigger);
    instance.open();
  });

  function boot() {
    var instance = ensureModalInstance();
    if (instance) applyEditorPreview(instance);
    ensureFormInstance();
  }

  function refreshEditorModal(event) {
    var section = event && event.target;
    if (section && !section.querySelector && section.detail && section.detail.sectionId) {
      section = document.getElementById('shopify-section-' + section.detail.sectionId);
    }
    if (section && section.querySelector) {
      var hasModal = !!section.querySelector('[data-rng-apply-modal]');
      var hasForm = !!section.querySelector('[data-rng-apply-form]');
      if (!hasModal && !hasForm) return;
      if (hasForm) formInstance = null;
      if (hasModal || hasForm) modalInstance = null;
    } else {
      modalInstance = null;
      formInstance = null;
    }

    boot();
  }

  document.addEventListener('shopify:section:load', refreshEditorModal);
  document.addEventListener('shopify:section:select', refreshEditorModal);
  document.addEventListener('shopify:section:reorder', refreshEditorModal);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
